import { Link } from "react-router-dom";
import { Phone, MessageCircle, MapPin, ClipboardList } from "lucide-react";
import { CALL_NUMBER, WHATSAPP_NUMBER } from "../data/services";
import { useLanguage } from "../i18n/LanguageContext";

export const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="bg-stone-900 text-stone-300 py-14" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img
              src="/assets/logo.png"
              alt="Alpha & More logo"
              className="h-12 w-12 rounded-full object-cover"
            />
            <span className="font-display text-xl font-semibold text-white">
              Alpha <span className="text-[#E85D75]">&amp;</span> More
            </span>
          </div>
          <p className="mt-4 text-sm text-stone-400 leading-relaxed max-w-xs">{t.footer.tagline}</p>
          <Link
            to="/bookings"
            data-testid="footer-bookings-link"
            className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-stone-300 hover:text-white transition-colors duration-200"
          >
            <ClipboardList className="w-4 h-4 text-[#E85D75]" /> {t.footer.bookings}
          </Link>
        </div>
        <div>
          <h4 className="text-sm font-semibold tracking-widest text-white mb-4 uppercase">
            {t.footer.contact}
          </h4>
          <a
            href={`tel:${CALL_NUMBER}`}
            data-testid="footer-call-link"
            className="flex items-center gap-2 text-sm hover:text-white transition-colors duration-200"
          >
            <Phone className="w-4 h-4 text-[#E85D75]" /> {t.callHelp}: {CALL_NUMBER}
          </a>
          <a
            href={`https://wa.me/${WHATSAPP_NUMBER}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-link"
            className="mt-3 flex items-center gap-2 text-sm hover:text-white transition-colors duration-200"
          >
            <MessageCircle className="w-4 h-4 text-[#25D366]" /> WhatsApp: {WHATSAPP_NUMBER.replace(/^91/, "")}
          </a>
        </div>
        <div>
          <h4 className="text-sm font-semibold tracking-widest text-white mb-4 uppercase">
            {t.footer.areas}
          </h4>
          <p className="flex items-start gap-2 text-sm text-stone-400 leading-relaxed">
            <MapPin className="w-4 h-4 text-[#4A7C59] shrink-0 mt-0.5" />
            {t.footer.areasText}
          </p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-8 mt-10 pt-6 border-t border-stone-800 text-xs text-stone-500">
        © {new Date().getFullYear()} Alpha &amp; More. {t.footer.rights}
      </div>
    </footer>
  );
};
